var map = {
	"./account-icon.svg": "0d8b",
	"./account-statement.svg": "bf4d",
	"./affiliate-programme.svg": "8941",
	"./deposit.svg": "5ef2",
	"./dots.svg": "dbb1",
	"./education.svg": "07db",
	"./partner-program.svg": "7f85",
	"./personal-details.svg": "a645",
	"./play.svg": "8fa8",
	"./trading.svg": "31e0",
	"./transfer.svg": "10ea",
	"./upload-documents.svg": "4868",
	"./user-profile.svg": "2fee",
	"./wallet-left-dark.svg": "8fa9",
	"./wallet-left.svg": "dffa",
	"./wallet.svg": "6f5f",
	"./webtrader.svg": "7a00",
	"./withdrawal.svg": "4c99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6fbe";